import React from 'react';
import PageSyle from '../style';
import NextBackNav from '../../../components/nextBackNav';
import RoundScreen from '../../../components/roundScreen';
import MultiHalfText from '../../../components/MultiHalfText';

export default function Page06({nextPressed, backPressed, nextSlideExzists, previousSlideExzists}) {
	let style = PageSyle();
	return (
		<div style={style.outerStyle()}>
			<MultiHalfText first='Bottom Heavy / Core' second='Workout 04' mt={true} />
			<RoundScreen
				isNumbered={false}
				rounds={[
					[
						{
							header: '(A) Glutes / Hamstrings',
							value: 'Kneeling Hip Thrusts w/(DB) (optional)',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 12',
						},
						{
							header: 'ABS / Core',
							value: 'Plank',
						},
						{
							header: 'Sec / Minutes',
							value: '45 sec',
						},
					],
					[
						{
							header: '(A) Glutes / Hamstrings',
							value: 'RDL’s w/(DB)',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 15',
						},
						{
							header: 'ABS / Core',
							value: 'Leg - Lifts',
						},
						{
							header: 'Sec / Minutes',
							value: '30 min',
						},
					],
					[
						{
							header: '(A) Glutes / Hamstrings',
							value: 'Sumo Squats',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 12',
						},
						{
							header: 'ABS / Core',
							value: 'Rest',
						},
						{
							header: 'Sec / Minutes',
							value: '...',
						},
					],
					[
						{
							header: '(A) Glutes / Hamstrings',
							value: 'Forward Lunges',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 15',
						},
						{
							header: 'ABS / Core',
							value: 'Russian Twists',
						},
						{
							header: 'Sec / Minutes',
							value: '30 min',
						},
					],
					[
						{
							header: '(A) Glutes / Hamstrings',
							value: 'Glute Bridge',
						},
						{
							header: 'Sets / Reps',
							value: '4 x 20',
						},
						{
							header: 'ABS / Core',
							value: 'Plank',
						},
						{
							header: 'Sec / Minutes',
							value: '45 sec',
						},
					],
				]}
			/>
			<NextBackNav
				message='Ready to continue?'
				mt={true}
				nextPressed={nextPressed}
				backPressed={backPressed}
				nextSlideExzists={nextSlideExzists}
				previousSlideExzists={previousSlideExzists}
			/>
		</div>
	);
}
